import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeLines: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"code-lines"} maskId="square-filled-radius-0-stroke-1-IconCodeLines"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H14V5H2V4ZM17 4H22V5H17V4ZM2 11.5L9 11.5V12.5L2 12.5L2 11.5ZM22 12.5L12 12.5V11.5L22 11.5V12.5ZM2 19L11 19V20L2 20L2 19ZM14 20V19L22 19V20L14 20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCodeLines;
